import { render, staticRenderFns } from "./lensmanDetail.vue?vue&type=template&id=2dc7cc20&"
import script from "./lensmanDetail.vue?vue&type=script&lang=js&"
export * from "./lensmanDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports